const initialState = {
    isNewTag:false,
    dataPrioritass:[],
    modalDataNonPrioritas: false,
    modalVerifikasi: false,
    modalUpload: false,
    modalTags: false,
    formMetadata: {
        Id:null,
        Period: {},
        UrlName:"",
        License: {},
        DataScope: {},
        Frequency: {},
        Agency: {},
        DatasetCategory: {},
        DatasetType: {},
        GeoportalTypeKey:{},
        GeoportalParameters:[],
        Name: '',
        LicenseId: '',
        DataScopeId: '',
        DataSource: '',
        FrequencyId: '',
        TagIds:[],
        Tags:[],
        Title: '',
        Description: '',
        IsPublish:false,
        Year:'',
        AgencyId: '',
        DatasetCategoryId: '',
        DatasetTypeid: '',
        FileUpload: '',
        Atributes:[],
    },
    formDataset: {
        Id:null
    }

}

const dataNonPrioritasReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'MODAL_DATA_NON_PRIORITAS':
            return { ...state, modalDataNonPrioritas: action.payload }
        case 'MODAL_VERIFIKASI':
            return { ...state, modalVerifikasi: action.payload }
        case 'DATA_NON_PRIORITASS':
            return { ...state, dataPrioritass: action.payload }
        case 'DATA_NON_PRIORITAS':
            return { ...state, dataPrioritas: action.payload }
        case 'MODAL_UPLOAD':
            return { ...state, modalUpload: action.payload }
        case 'MODAL_TAGS':
            return { ...state, modalTags: action.payload }
        case 'RESET_FORM_DATA_NON_PRIORITAS':
            return { ...state, formMetadata: initialState.formMetadata }
        case 'FORM_DATA_NON_PRIORITAS':
            return {
                ...state,
                formMetadata: {
                    ...state.formMetadata,
                    [action.formType]: action.formValue
                }
            }
        case 'ARRAY_ATTRIBUTES':
            return { 
                ...state,
                formAttr:[...state.formAttr, action.payload]
            }
        case 'SET_IS_NEW_TAG':
            return { ...state, isNewTag: action.payload }
        default:
            return state
    }
}

export default dataNonPrioritasReducer;